const WORDS = ["Diye", "Dost", "Drama", "Mithai ki doosri plate", "Taash ki baazi", "Main character energy", "Photo pe photo", "Traditional only"];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div className="bg-yellow-print overflow-hidden border-b-[2.5px] border-[var(--navy)] py-3" aria-hidden="true">
      <div className="marquee-track flex w-max">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center">
            {row.map((w, i) => (
              <span key={i} className="flex items-center">
                <span className={`whitespace-nowrap px-5 text-2xl sm:text-3xl ${i % 3 === 2 ? "font-serif-i text-[var(--pink-deep)]" : "font-poster text-[var(--navy)]"}`}>{w}</span>
                <svg viewBox="-16 -16 32 32" className="h-5 w-5"><path d="M0 -14 C2 -4 4 -2 14 0 C4 2 2 4 0 14 C-2 4 -4 2 -14 0 C-4 -2 -2 -4 0 -14 Z" fill="#D81B60" stroke="#142344" strokeWidth="2" /></svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
